import { AbstractDatabase, ObjectRef, ListRef, QueryFn } from "./database";
// Include firebase database abstraction or fire-database-ssr
import { FireDatabase } from "@database";

import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Database } from "@angular/fire/database";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
/**
 * Abstraction between database backend and application.
 * Implements AbstractDatabase (currently AngularFire) as a service.
 */
export class DatabaseService implements AbstractDatabase {

    public database = new FireDatabase(this.af, this.http);

    constructor(private af: Database, private http: HttpClient) {
    }

    /**
     * @override init
     */
    public init(enableDbCache: boolean, offlineContentCache: string): Promise<any> {
        return this.database.init(enableDbCache, offlineContentCache);
    }

    /**
     * @override awaitInit
     */
    public awaitInit(): Promise<any> {
        return this.database.awaitInit();
    }

    /**
     * @override enableOfflineMode
     */
    public enableOfflineMode(enable: boolean) {
        return this.database.enableOfflineMode(enable);
    }

    /**
     * @override list
     */
    public list<T>(ref: string, query?: QueryFn): ListRef<T> {
        return this.database.list(ref, query);
    }

    /**
     * @override object
     */
    public object<T>(ref: string): ObjectRef<T> {
        return this.database.object(ref);
    }

    /**
     * @override isNetworkConnected
     */
    public isNetworkConnected(): Promise<boolean> {
        return this.database.isNetworkConnected();
    }

    /**
     * @override watchNetworkConnected
     */
    public watchNetworkConnected() : Observable<boolean> {
        return this.database.watchNetworkConnected();
    }

    /**
     * @override serverTime
     */
    public serverTime(): any {
        return this.database.serverTime();
    }
}
